import { useTheme } from '@mui/material';
const useAsideStyles = () => {
    const theme = useTheme();
    return {
        containerStyles: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: 'calc(100dvh - 240px)',
            pt: '15px',
            gap: 1.25, // 10px
            borderRadius: 1.5,
            background: theme.palette.background.paper,
            // boxShadow: theme.customShadows.card
            border: `1px solid ${theme.palette.action.active}`,
        },
        headerStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
            px: 2
        },
        filterButtonStyles: {},
        listContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            '.incident-tile:last-child': {
                border: 'none'
            },
            scrollbarWidth: 'none' /* For Firefox */,
            '-ms-overflow-style': 'none' /* For Internet Explorer 10+ */
        }
    };
};
export default useAsideStyles;
